//import axios from 'axios'
import router from "@/router";
import {eposAxios} from "@/interceptors/axios";
import VueCookies from "vue-cookies";

export default  {
    state(){
        return {
            token: null,
            userId: null,
            userDetails: null,
            userWorkstation: null
        }
    },
    getters : {
        user (state) {
            return state.userDetails
        },
        token (state) {
            //return state.token
            return VueCookies.get('epos2_token')
        },
        ifAuthenticated (state) {
            //return state.token !== null
            return VueCookies.get('epos2_token') !== null
        }
    },
    actions : {
        reset(){
            this.success = false;
            this.error = false;
            for(let field in this.formData){
                this.formData[field] = null;
            }
        },
        async checkAuth ({commit}, authData ) {
           /* const instance = axios.create({
                withCredentials: true
            })*/
            eposAxios.post('/index.php?page=ajax&function=processLogin', {
                username: authData.username,
                password: authData.password,
                workstation: 1,
                returnSecureToken: true
            })
                .then(res => {
                    //console.log('response data: ')
                    //console.log(res.data)
                    if (res.data.result === false) {

                        this.error = true
                        let errorData = {
                            errorStatus: false,
                            errorMsg: null,
                        }
                        errorData.errorStatus = true
                        errorData.errorMsg = res.data.status
                        //console.log(res.data.status)

                        /*commit('showError', {
                          error: res.data.status
                        })
                        console.log(this.error)
                        console.log(this.errorMsg)*/
                        //console.log('error data: ')
                        //console.log(errorData)
                        return this.errorData;
                    }
                    else {
                        //commit('hideError')
                       // localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('userId', res.data.data.userId)
                        commit('authUser', {
                            //token: res.data.data.token,
                            userId: res.data.data.userId
                        })

                        console.log('REDIRECT');
                        router.push("/dashboard")

                    }

                })
                .catch(error => console.log(error))
        },
        async login ({commit}, authData) {
            /*const instance = axios.create({
                withCredentials: true
            })*/
            eposAxios.post('/index.php?page=ajax&function=processLogin', {
                username: authData.username,
                password: authData.password,
                workstation: 1,
                returnSecureToken: true
            })
                .then(res => {
                    //console.log('response data: ')
                    //console.log(res.data)
                    if (res.data.result === false) {

                        this.error = true
                        let errorData = {
                            errorStatus: false,
                            errorMsg: null,
                        }
                        errorData.errorStatus = true
                        errorData.errorMsg = res.data.status
                        //console.log(res.data.status)

                        /*commit('showError', {
                          error: res.data.status
                        })
                        console.log(this.error)
                        console.log(this.errorMsg)*/
                        //console.log('error data: ')
                        //console.log(errorData)
                        return this.errorData;
                    }
                    else {
                        //commit('hideError')
                        //localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('userId', res.data.data.userId)
                        commit('authUser', {
                            //token: res.data.data.token,
                            userId: res.data.data.userId
                        })

                        console.log('REDIRECT');
                        router.push("/dashboard")

                    }

                })
                .catch(error => console.log(error))
        },
       /* async loginOK ({commit}, authData) {
           // const headers = {
           //   'Authorization': 'Bearer '+localStorage.getItem("token"),token: token
           // };
            axios({
                method: 'post',
                url: process.env.VUE_APP_EPOS2_API_BASE+'/api/auth',
                params: {},
                withCredentials: true,
                headers:{Authorization:'Basic '+btoa(authData.username+':'+authData.password)}
            })
                .then(res => {
                    //console.log('response data: ')
                    //console.log(res.data)
                    if (res.data.result === false) {

                        this.error = true
                        let errorData = {
                            errorStatus: false,
                            errorMsg: null,
                        }
                        errorData.errorStatus = true
                        errorData.errorMsg = res.data.status
                        //console.log(res.data.status)


                        //console.log('error data: ')
                        //console.log(errorData)
                        return this.errorData;
                    }
                    else {
                        //commit('hideError')
                        localStorage.setItem('token', res.data.data.token)
                        localStorage.setItem('userId', res.data.data.userId)
                        commit('authUser', {
                            token: res.data.data.token,
                            userId: res.data.data.userId
                        })

                        console.log('REDIRECT');
                        router.push("/dashboard")

                    }

                })
                .catch(error => console.log(error))
        },*/
        logout ({commit}) {
            commit('clearAuth')
            localStorage.removeItem('token')
            localStorage.removeItem('userId')
            localStorage.removeItem('userWorkstation')

            VueCookies.remove('epos2_token')
            VueCookies.remove("epos2_userid");
            VueCookies.remove("epos2_workstationid");
            router.push("/logout")

        },
        AutoLogin ({commit}) {
            const token = localStorage.getItem('token')
            if (!token) {
                return
            }
            const userId = localStorage.getItem('userId')
            commit('authUser', {
                //token: token,
                userId: userId
            })
        },
    },
    mutations : {
        authUser (state, userData) {
            state.token = userData.token
            state.userId = userData.userId
            state.userDetails = userData.userDetails
            state.userWorkstation = userData.userWorkstation

            //localStorage.setItem('token', userData.token)
            localStorage.setItem('userId', userData.userId)
            localStorage.setItem('userWorkstation', userData.userWorkstation)
            localStorage.setItem('userDetails', userData.userDetails)
        },
        clearAuth (state) {
            state.token = null
            state.userId = null
            state.userDetails = null
            state.userWorkstation = null
        },
    }
}